import { useEffect, useRef } from "react";
import _ from "lodash";
import { Card, Col, Row, Space, Statistic } from "antd";
import { formattedAmount } from "../../utils/index";
import { useDataStore } from "../../store";
import echarts from "../../themes/roma";
import './Accountant.css';

export function Accountant (){

    const ref = useRef();
    const { avgMonthIncome, avgMonthExpense, totalIncome, totalExpense, incomeMonthly, expenseMonthly } = useDataStore(state => state.accountant);

    useEffect(() => {

        if( incomeMonthly && expenseMonthly ){
            let chart = echarts.init(ref.current, 'roma');
            let series = accountant2Series( incomeMonthly, expenseMonthly );
            chart.setOption( series );
        }

    }, [ incomeMonthly, expenseMonthly ]);

    return <Card title="收支统计">
        <Space direction="vertical">
            <Row gutter={16}>
                <Col span={6}>
                    <Statistic title="总收入" value={formattedAmount(totalIncome)} />   
                </Col>
                <Col span={6}>
                    <Statistic title="平均月收入" value={formattedAmount(avgMonthIncome)} />
                </Col>
                <Col span={6}>
                    <Statistic title="总支出" value={formattedAmount(totalExpense)} />
                </Col>
                <Col span={6}>
                    <Statistic title="平均月支出" value={formattedAmount(avgMonthExpense)} />
                </Col>
            </Row>
            &nbsp;
            <Row gutter={16}>
                <Col span={24}>
                    <div ref={ref} className="accountant-chart"></div>
                </Col>
            </Row>
        </Space>
    </Card>
}

function accountant2Series ( incomeData, expenseData ){
    let sources = _.sortBy(_.keys(incomeData).map( key => {
        return [
            key,
            _.toNumber(incomeData[key] || 0),
            _.toNumber(expenseData[key] || 0)
        ]
    }));

    return {
        title: {},
        dataset: {
            source: [[ 'sources', '收入', '支出' ], ...sources ]
        },
        legend: {},
        grid: {
            top: 30,
            bottom: 30,
            right: 10
        },
        tooltip: {
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#ccc'
                }
            }
        },
        xAxis: { 
            type: 'category',
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
        },
        yAxis: {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        series: [
            { 
                type: 'bar',  
            }, 
            { 
                type: 'bar',
            }
        ]
    }
}